import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login/login.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProjectComponent } from './project/project/project.component';
import { QuotesComponent } from './project/quotes/quotes.component';
import { InvoicesComponent } from './project/invoices/invoices.component';
import { ChangeOrdersComponent } from './project/change-orders/change-orders.component';
// Sales order section hidden from the portal (component kept for re-enabling).
// import { SalesOrdersComponent } from './project/sales-orders/sales-orders.component';
import { ProgressComponent } from './project/progress/progress.component';
import { DocumentsComponent } from './project/documents/documents.component';
import { DocumentComponent } from './project/document/document.component';
import { PortalAuthGuard } from './portal-auth.guard';
import { PortalGuestGuard } from './portal-guest.guard';

const routes: Routes = [
	{ path: 'login', component: LoginComponent, canActivate: [PortalGuestGuard] },
	{ path: 'forgot-password', component: ForgotPasswordComponent },
	{ path: 'reset-password/:token', component: ResetPasswordComponent },
	{ path: 'accept-invite/:token', component: AcceptInviteComponent },
	// Where a staff preview lands. It has no screen of its own — the handshake happens in
	// AppComponent before routing matters, and from here on a preview browses the real portal.
	{ path: 'portal-preview', redirectTo: '', pathMatch: 'full' },
	{ path: '', component: DashboardComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id', component: ProjectComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/quotes', component: QuotesComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/invoices', component: InvoicesComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/change_orders', component: ChangeOrdersComponent, canActivate: [PortalAuthGuard] },
	// Sales order section hidden from the portal (component kept for re-enabling).
	// { path: 'project/:id/sales_order', component: SalesOrdersComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/progress', component: ProgressComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/documents', component: DocumentsComponent, canActivate: [PortalAuthGuard] },
	{ path: 'project/:id/document/:quoteId', component: DocumentComponent, canActivate: [PortalAuthGuard] },
	{ path: '**', redirectTo: '' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
	exports: [RouterModule]
})
export class AppRoutingModule {}
